.alert {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: var(--radius);
  border: 1px solid transparent;
  border-left-width: 3px;
  font-size: 13px;
  color: var(--text);
}

.icon {
  display: inline-flex;
  flex-shrink: 0;
}

.text {
  flex: 1;
  min-width: 0;
  line-height: 1.35;
}

/* Inline action (Switch / Retry). Neutral compact pill so it reads consistently across
   severities and doesn't compete with the tinted alert body. */
.action {
  flex-shrink: 0;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  padding: 3px 10px;
  border: 1px solid var(--gray-border);
  border-radius: 999px;
  background: var(--white);
  color: var(--text);
  cursor: pointer;
}

.action:hover {
  border-color: var(--text);
}

.info {
  background: var(--gray-bg);
  border-color: var(--gray-border);
  border-left-color: var(--blue-light);
}
.info .icon { color: var(--blue-light); }

.warning {
  background: var(--yellow-bg);
  border-color: var(--yellow);
  border-left-color: var(--yellow);
}
.warning .icon { color: var(--yellow); }

.error {
  background: var(--red-bg);
  border-color: var(--red-border);
  border-left-color: var(--red);
}
.error .icon { color: var(--red); }
